import { authService } from '@services/index';
import { useQuery } from '@tanstack/react-query';

export default function useQueryUserProfile() {
	return useQuery({
		queryKey: ['AuthUserProfile'],
		queryFn: () => authService.getUserProfile()
	});
}
